/**
 * Making a team (you own it), then showing it.
 */
import { createSignal, type JSX } from "solid-js";
import { usePages } from "./context";

/** A name field and a button; `id` prefixes the elements' ids (`<id>-name`, `<id>-create`). */
export function NewTeam(props: { id: string }): JSX.Element {
  const { accounts, server, go } = usePages();
  const [name, setName] = createSignal("");
  /** Makes the team and opens it. */
  const create = async () => {
    const team = await accounts.createTeam(server, name());
    if (!team) return;
    setName("");
    go({ page: "team", team: team.id });
  };
  return (
    <form
      class="row-inline"
      onSubmit={(e) => {
        e.preventDefault();
        void create();
      }}
    >
      <input class="field" id={`${props.id}-name`} placeholder="Team name" required value={name()} onInput={(e) => setName(e.currentTarget.value)} />
      <button type="submit" class="btn primary" id={`${props.id}-create`}>
        New team
      </button>
    </form>
  );
}
